/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import { graphql } from 'react-apollo';

import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import LoadingModal from 'components/LoadingModal';
import Row from 'components/Row';
import Table from 'components/Table';
import TEACHER_INFO_COLLECTION_MODAL_QUERY from 'user/queries/TeacherInfoCollectionModalQuery.gql';
import TeacherInfoCollectionRow from 'user/components/TeacherInfoCollectionRow';

import type { TeacherInfoCollectionModal_me_ownedClasses } from 'user/queries/__generated__/TeacherInfoCollectionModal';

import './styles/TeacherInfoCollectionModal.scss';

const SCREEN_NAME = 'teacher_info_collection';

type Props = {
  groups: ?(TeacherInfoCollectionModal_me_ownedClasses[]),
  onRequestHide: () => void,
};

export class TeacherInfoCollectionModal extends React.Component<Props, $FlowFixMeState> {
  state = {
    isRowValid: {},
  };

  static childContextTypes = {
    eventScreenName: PropTypes.string,
  };

  getChildContext() {
    return {
      eventScreenName: SCREEN_NAME,
    };
  }

  renderTable(groups: TeacherInfoCollectionModal_me_ownedClasses[]) {
    const rows = groups.map(group => {
      const setValid = isValid => {
        const rowValid = this.state.isRowValid;
        rowValid[group.id] = isValid;
        this.setState({ isRowValid: rowValid });
      };

      return (
        <TeacherInfoCollectionRow
          key={group.id}
          group={group}
          onValid={setValid.bind(this, true)}
          onInvalid={setValid.bind(this, false)}
        />
      );
    });

    return (
      <Table
        head={
          <tr>
            <th className="TeacherInfoCollectionModal-table-group">Class</th>
            <th className="TeacherInfoCollectionModal-table-org">School</th>
            <th className="TeacherInfoCollectionModal-table-grades">Grade(s)</th>
            <th className="TeacherInfoCollectionModal-table-subject">Subject</th>
          </tr>
        }
        className="TeacherInfoCollectionModal-table">
        <tbody>{rows}</tbody>
      </Table>
    );
  }

  render() {
    const { groups } = this.props;
    if (!groups) {
      return <LoadingModal />;
    }

    return (
      <Dialog
        hideCloseButton
        hideOnEscape={false}
        size="xlarge"
        subtext="Make sure you have the correct school, grade and subject for each class"
        title="Update your class information"
        className="TeacherInfoCollectionModal"
        eventScreenName={SCREEN_NAME}>
        <BoxBody>
          <Row>{this.renderTable(groups)}</Row>
          <Button
            eventElementName="TeacherInfoCollectionModal-done"
            disabled={Object.values(this.state.isRowValid).some(v => !v)}
            onClick={this.props.onRequestHide}>
            Done
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}

const withGroups = graphql(TEACHER_INFO_COLLECTION_MODAL_QUERY, {
  props: ({ data }) => ({
    groups: data.me ? data.me.ownedClasses : null,
  }),
});

export default withGroups(TeacherInfoCollectionModal);
